export class ConfigUtil{
    static userSessioned: string = "userSessioned";
    static credentialSessioned: string = "credentialSessioned";
    static machineSessioned: string = "machineSessioned"; 
}
